import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface OutletTypeNameState {
  OutlettypeNamePrimary: string | null;
  OutlettypeNameSecondary: string | null;
}

const initialState: OutletTypeNameState = {
  OutlettypeNamePrimary: null,
  OutlettypeNameSecondary: null,
};

const outletTypeNameSlice = createSlice({
  name: "outletTypeName",
  initialState,
  reducers: {
    setOutletTypeNames(state, action: PayloadAction<{ primary: string; secondary: string }>) {
      state.OutlettypeNamePrimary = action.payload.primary;
      state.OutlettypeNameSecondary = action.payload.secondary;
    },
  },
});

export const { setOutletTypeNames } = outletTypeNameSlice.actions;
export default outletTypeNameSlice.reducer;